import { render, staticRenderFns } from "./LevantamientoProjectModal.vue?vue&type=template&id=f0fb2132&scoped=true"
import script from "./LevantamientoProjectModal.vue?vue&type=script&lang=js"
export * from "./LevantamientoProjectModal.vue?vue&type=script&lang=js"
import style0 from "./LevantamientoProjectModal.vue?vue&type=style&index=0&id=f0fb2132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0fb2132",
  null
  
)

export default component.exports